<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="7" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"/>
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table
      show-empty
      empty-text="Please wait while the evaluations load."
      striped
      responsive
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage" 
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
    >
      <template #head(user)>
        <div v-if="role == 'preceptor'">Student</div>
        <div v-else>Preceptor</div>
      </template>
      <template v-slot:cell(user)="row">
        <div v-if="role == 'preceptor'">{{ row.item.user.name }}</div>
        <div v-else>{{ row.item.preceptor_name }}</div>
      </template>
      <template v-slot:cell(created_at)="row" >
      <div v-if="row.item.completed_date">Assessed: {{ moment(row.item.completed_date).format('MMM DD YYYY') }}</div>
      Sent: {{ moment(row.item.created_at).format('MMM DD YYYY') }}
      <span v-if="row.item.evaluation_file"><br>Uploaded: {{ moment(row.item.updated_at).format('MMM DD YYYY') }}</span>
      </template>
      <template v-slot:cell(attendance)="row">{{ row.item.attendance }}</template>
      <template v-slot:cell(student_viewed)="row">
        <div v-if="row.item.student_viewed == 1">Yes</div>
        <div v-else>
          <span class="text-success">No</span>
        </div>
        <div v-if="row.item.student_viewed_date">{{ moment(row.item.student_viewed_date).format('MMM DD YYYY') }}</div>
      </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button-group>
          <b-button class="btn btn-warning" v-if="row.item.preceptor_id == user.id" @click.stop="editEval(row.item.id)"><span class="icon icon-pencil"></span></b-button>
          <b-button @click="viewEvaluation(row.item.id)" class="btn btn-success">
            <span class="icon icon-eye"> View</span>
          </b-button>
          <b-button
            v-if="role == 'instructor' || role == 'school'"
            @click="print(row.item.id)"
            class="btn btn-primary"
          >
            <span class="icon icon-download">Download</span>
          </b-button>
        </b-button-group>
      </template>
    </b-table>
    <b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
  </div>
</template>

<script>
const items = [];
var moment = require("moment");
export default {
  props: ["evaluations", "surl", "user_role", "current_user"],
  data() {
    return {
      moment: moment,
      items: this.evaluations,
      user: this.current_user,
      url: this.surl,
      role: this.user_role,
      fields: [
        {
          key: "rotation",
          label: "Rotation"
        },
        {
          key: "user",
          label: "Preceptor"
        },
        {
          key: "created_at",
          label: "Date"
        },
        {
          key: "attendance",
          label: "On Time"
        },
        {
          key: "total_score",
          label: "Score"
        },
        {
          key: "student_viewed",
          label: "Viewed"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: this.evaluations.length,
      pageOptions: [15, 25, 35, 50],
      filter: null,
      sortBy: "created_at",
      sortDesc: true
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  filters: {
    uppercase: function(v) {
      return v.toUpperCase();
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewEvaluation(id) {
      window.location.href = this.surl + id;
    },
    print(id) {
      window.location.href = "/print/evaluation/" + id;
    },
    editEval(id) {
      if (this.user_role == 'instructor') {
        window.location.href = ('/instructor/evaluation/view/' + id);
      }
      if (this.user_role == 'preceptor') {
        window.location.href = ('/preceptor/evaluation/view/' + id);
      } 
    }
  }
};
</script>

<!-- table-complete-1.vue -->